import CookieConsentManager from '../Cookies/CookieConsentManager';
import MessageService from '../MessageService';
import RedirectService from '../RedirectService';
import UiService from '../UiService';

export default class CookieConsentScreen {
    /**
     * CookieConsentScreen constructor
     * @param {MessageService} messageService
     * @param {UiService} uiService
     */
    constructor(messageService, uiService) {
        this.messageService = messageService;
        this.uiService = uiService;
    }

    getCookieConsent() {
        return new Promise(async resolve => {
            this.uiService.switchScreen('#wrapper-base-screen');

            document.getElementById('re-consent-allow').addEventListener('click', async () => {
                resolve(true);
            });

            document.getElementById('re-consent-deny').addEventListener('click', () => {
                setTimeout(async () => {
                    if (confirm(this.messageService.uiMessages.dc_cookie_consent_denied_confirmation)) {
                        resolve(false);
                    }
                }, 100); // slightly delayed to give chance to the UI to be updated (buttons.click)
            });

        });
    }
}
